import React, { useState } from "react";
import { sendPersonalInfo } from "../API/requests";
import Button from "../Components/Button";
import TextInput from "../Components/TextInput";
const ChargeCardForm = ({
  onResRecieve,
  setPageState,
  mobileNumber,
  otpId,
  setIsLoading,
  setFinalRes,
  resetOperation,
}) => {
  const [values, setValues] = useState({});

  const valueChangeHandler = (name, value) => {
    setValues({ ...values, [name]: value });
  };
  const numericValueChangeHandler = (name, value) => {
    if (value) value = value.replace(/\D/g, "");
    setValues({ ...values, [name]: value });
  };

  const fetchData = (e) => {
    setIsLoading(true);
    sendPersonalInfo(values, mobileNumber, otpId)
      .then((res) => {
        setPageState("resPage");
        setFinalRes(res);
      })
      .catch((error) => {
        onResRecieve(error.response.data);
      });
    e.preventDefault();
  };

  const checkDisabled = () => {
    if (!values) return true;
    if (values.pan && values.password && values.nationalCode) return false;
    return true;
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (checkDisabled()) return;
    fetchData();
  };

  return (
    <form className="info-form" onSubmit={submitHandler}>
      <div>
        <div className="text-and-label">
          <div className="text-label">کد ملی</div>
          <div className="text-input-box">
            <TextInput
              autoFocus
              name="nationalCode"
              onChange={numericValueChangeHandler}
              value={values.nationalCode}
              kind="nationalCode"
            />
          </div>
        </div>
        <div className="text-and-label">
          <div className="text-label">شماره کارت</div>
          <div className="text-input-box">
            <TextInput
              name="pan"
              onChange={numericValueChangeHandler}
              value={values.pan || ""}
              kind="pan"
            />
          </div>
        </div>
        <div className="text-and-label">
          <div className="text-label">رمز کارت</div>
          <div className="text-input-box">
            <TextInput
              type="password"
              name="password"
              onChange={valueChangeHandler}
              value={values.password || ""}
            />
          </div>
        </div>
      </div>

      <Button
        onClick={fetchData}
        text="تایید"
        variant="contained"
        disabled={checkDisabled()}
      />
    </form>
  );
};

export default ChargeCardForm;
